<div class="container-xl">
    <div class="titration-plan-section">
        <div class="titration-plan-form">
            <div class="titration-plan-form-row">
                <strong>Einstellungen</strong>
                <div class="icon mr-0" (click)="fnShowRechnerInfoPopup(0)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
            </div>

            <div class="titration-plan-form-row produktauswahl full-width-input">
                <div class="icon" (click)="fnShowRechnerInfoPopup(1)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>{{ProductTHCText}}</span>
                </div>
                <div class="form-row-input">
                    <ng-container *ngIf="isPrivatePage">
                        <select class="form-control-sm" [(ngModel)]="productNameInput" (change)="inputChangeProduct()">
                            <ng-container *ngFor="let item of productList">
                                <option [value]="item.ProductName">{{item.ProductName}}</option>
                            </ng-container>
                        </select>
                    </ng-container>
                    <ng-container *ngIf="!isPrivatePage">
                        <select class="form-control-sm" [(ngModel)]="thcKonzentrationInput" (change)="inputChangeTHC()">
                            <ng-container *ngFor="let item of thcKonzentrationList">
                                <option [value]="item.ProductName">{{item.ProductName}}</option>
                            </ng-container>
                        </select>
                    </ng-container>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(2)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Dosierungsart</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="artDerDorierungInput" (change)="inputChangeArt()">
                        <ng-container *ngFor="let item of artDerDorierungList">
                            <option [value]="item.value">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="icon" (click)="fnShowRechnerInfoPopup(3)">
                    <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                </div>
                <div class="form-row-text">
                    <span>Verschreibungsmenge</span>
                </div>
                <div class="form-row-input">
                    <select class="form-control-sm" [(ngModel)]="verschreibungsmengeInput" (change)="inputChangeVers()">
                        <ng-container *ngFor="let item of verschreibungsmengeList">
                            <option [value]="item.value">{{item.text}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="titration-plan-form-row flex-column">
                <div class="form-row-text w-100 flex-row">
                    <div class="icon" (click)="fnShowRechnerInfoPopup()">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <p class="text-center mb-2 w-100">Dosierungsschema in {{dorierungType}}</p>
                </div>
                <div class="form-row-input w-100 flex-column">
                    <div class="slider-rows">
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="morgensVal" [options]="dosierungsSchemaOptions('morgens')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('morgens',morgensVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>morgens</p>
                                <p>{{morgensDisplay}}</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="mittagsVal" [options]="dosierungsSchemaOptions('mittags')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('mittags',mittagsVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>mittags</p>
                                <p>{{mittagsDisplay}}</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="abendsVal" [options]="dosierungsSchemaOptions('abends')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('abends',abendsVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>abends</p>
                                <p>{{abendsDisplay}}</p>
                            </div>
                        </div>
                        <div class="slider-row">
                            <div class="slider-view">
                                <ngx-slider [(value)]="zurNachtVal" [options]="dosierungsSchemaOptions('zur Nacht')" (valueChange)="sliderValueChange()" (userChange)="sliderUserChange('zur Nacht',zurNachtVal)"></ngx-slider>
                            </div>
                            <div class="slider-text">
                                <p>zur Nacht</p>
                                <p>{{zurNachtDisplay}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="titration-plan-form-row">
                <div class="d-flex align-items-center">
                    <div class="icon" (click)="fnShowRechnerInfoPopup(4)">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <span>Umrechnung bei CAM Wechsel</span>
                </div>
                <div class="expand-icon" [class.active]="expandedRow" (click)="expandedRow=!expandedRow">
                    <ng-container [ngSwitch]="partnerName">
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                            <img class="ex-icon" src="/images/private/titration/tilray/arrow-down.svg" alt="arrow-down.svg">
                            <img class="ex-icon" src="/images/private/titration/tilray/arrow-up.svg" alt="arrow-up.svg">
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                            <img class="ex-icon" src="/images/private/titration/hormosan/arrow-down.svg" alt="arrow-down.svg">
                            <img class="ex-icon" src="/images/private/titration/hormosan/arrow-up.svg" alt="arrow-up.svg">
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                            <img class="ex-icon" src="/images/private/420pharma/arrow-down.svg" alt="arrow-down.svg">
                            <img class="ex-icon" src="/images/private/420pharma/arrow-up.svg" alt="arrow-up.svg">
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <img class="ex-icon" src="/images/private/titration/arrow-down.svg" alt="arrow-down.svg">
                            <img class="ex-icon" src="/images/private/titration/arrow-up.svg" alt="arrow-up.svg">
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <ng-container *ngIf="expandedRow">
                <div class="titration-plan-form-row produktauswahl full-width-input">
                    <div class="icon" (click)="fnShowRechnerInfoPopup(5)">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <div class="form-row-text">
                        <span>{{ProductTHCText}}</span>
                    </div>
                    <div class="form-row-input">
                        <select class="form-control-sm" [(ngModel)]="CAMthcKonzentrationInput" (change)="inputChangeCAM('CAM THC Konzentration',CAMthcKonzentrationInput)">
                            <ng-container *ngFor="let item of CamThcKonzentrationList">
                                <option [value]="item.ProductName">{{item.ProductName}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>

                <div class="titration-plan-form-row">
                    <div class="icon" (click)="fnShowRechnerInfoPopup(6)">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <div class="form-row-text">
                        <span>Dosierungsart</span>
                    </div>
                    <div class="form-row-input">
                        <select class="form-control-sm" [(ngModel)]="CAMartDerDorierungInput" (change)="inputChangeCAM('CAM Dosierungsart',CAMartDerDorierungInput)">
                            <ng-container *ngFor="let item of CamArtDerDorierungList">
                                <option [value]="item.value">{{item.text}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>

                <div class="titration-plan-form-row">
                    <div class="icon" (click)="fnShowRechnerInfoPopup(7)">
                        <ng-container *ngTemplateOutlet="infoIcon"></ng-container>
                    </div>
                    <div class="form-row-text">
                        <span>Verschreibungsmenge</span>
                    </div>
                    <div class="form-row-input">
                        <select class="form-control-sm" [(ngModel)]="CAMverschreibungsmengeInput" (change)="inputChangeCAM('CAM Verschreibungsmenge',CAMverschreibungsmengeInput)">
                            <ng-container *ngFor="let item of CamVerschreibungsmengeList">
                                <option [value]="item.value">{{item.text}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>
            </ng-container>


        </div>
        <div class="titration-plan-block" id="titration-plan-block">
            <div class="header-section">
                <div class="header-content">
                    <h5>Dosierungsplan</h5>
                    <div [innerHTML]="getHeaderContent()"></div>
                </div>
                <div class="header-button header-button-paitent">
                    <p>Patient:in:</p>
                </div>
                <div class="header-button header-button-icon">
                    <div class="print-view-close show-on-blank" onClick="javascript:window.close('','_parent','');">
                        <span>Druckansicht schließen</span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52px" height="52px" viewBox="0 0 52 52" version="1.1">
                            <g id="DRuckansicht-Update-oct-2024" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Tilray---Druckansicht-Copy-4" transform="translate(-1445.000000, -167.000000)">
                                    <g id="Druckansicht-schließen" transform="translate(1277, 168.000000)">
                                        <path d="M170,0 L215,0 C217.761424,-5.07265313e-16 220,2.23857625 220,5 L220,45 C220,47.7614237 217.761424,50 215,50 L170,50 L170,50 L170,0 Z" id="Rectangle" fill="#C83232" />
                                        <g id="close" transform="translate(180.000000, 10.000000)">
                                            <circle id="Oval-Copy-4" fill="#FFFFFF" cx="15" cy="15" r="15" />
                                            <line x1="15" y1="6" x2="15" y2="24" id="Line-6-Copy-10" stroke="#C83232" stroke-width="2" stroke-linecap="round" transform="translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) " />
                                            <line x1="24" y1="15" x2="6" y2="15" id="Line-6-Copy-10" stroke="#C83232" stroke-width="2" stroke-linecap="round" transform="translate(15.000000, 15.000000) rotate(-315.000000) translate(-15.000000, -15.000000) " />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div class="header-button-icon-contianer button-on-blank">
                        <ul>
                            <li (click)="fnPrintPageData()">
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <img src="/images/private/titration/tilray/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <img src="/images/private/titration/hormosan/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <img src="/images/private/420pharma/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <img src="/images/private/titration/Drucken.svg" alt="Drucken.svg" />
                                    </ng-container>
                                </ng-container>
                            </li>
                            <li (click)="fnShowRezeptPopup()">
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <img src="/images/private/titration/tilray/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <img src="/images/private/titration/hormosan/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <img src="/images/private/420pharma/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <img src="/images/private/titration/Rezept.svg" alt="Rezept.svg" />
                                    </ng-container>
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="table-section">
                <div class="table-heading">Therapieplan für die Dosierung mit {{CAMartDdorierungName}}</div>
                <div class="table-responsive scrollbar">
                    <table class="table table-sm table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th class="morgens">
                                    <div>
                                        <span>MORGENS</span>
                                        <img class="icon" src="/images/private/titration/Morgens.svg" alt="Morgens.svg" />
                                    </div>
                                </th>
                                <th class="mittags">
                                    <div>
                                        <span>MITTAGS</span>
                                        <img class="icon" src="/images/private/titration/Mittags.svg" alt="Mittags.svg" />
                                    </div>
                                </th>
                                <th class="abends">
                                    <div>
                                        <span>ABENDS</span>
                                        <img class="icon" src="/images/private/titration/Abends.svg" alt="Abends.svg" />
                                    </div>
                                </th>
                                <th class="zurnacht">
                                    <div>
                                        <span>ZUR NACHT</span>
                                        <img class="icon" src="/images/private/titration/Zur Nacht.svg" alt="Zur Nacht.svg" />
                                    </div>
                                </th>
                                <th class="thcd">THC/Tag</th>
                                <th class="anmerkungen">Anmerkungen</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{tableDataObj.morgens.neueDosierung}}</td>
                                <td>{{tableDataObj.mittags.neueDosierung}}</td>
                                <td>{{tableDataObj.abends.neueDosierung}}</td>
                                <td>{{tableDataObj.zurNacht.neueDosierung}}</td>
                                <ng-container [ngSwitch]="true">
                                    <ng-container *ngSwitchCase="(partnerName==PartnerNamesEnum.DOSIS_EQ_TILRAY || partnerName==PartnerNamesEnum.DOSIS_EQ_HORMOSAN || partnerName==PartnerNamesEnum.DOSIS_EQ_420_PHARMA)">
                                        <td class="thcd">{{getTotalMilliTHCFormtted(2)}} mg</td>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <td class="thcd">{{getTotalMilliTHCFormtted(1)}} mg</td>
                                    </ng-container>
                                </ng-container>
                                <td class="anmerkungen"></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th class="morgens"></th>
                                <th class="mittags"></th>
                                <th class="abends"></th>
                                <th class="zurnacht"></th>
                                <th class="thcd"></th>
                                <th class="anmerkungen"></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="content-section">
                <div class="content-accordion" [class.active]="expandedContent">
                    <div class="content-accordion-header" (click)="expandedContent=!expandedContent">
                        <div>Gebrauchsanweisung für den/die Patient:in</div>
                    </div>
                    <div class="content-accordion-description">
                        <div class="accordion-desc pt-2">
                            <p>Die Dosierung erfolgt entweder mit einer 1-mL-Kolbenpipette (Graduierung 0,05 mL, Dosierung in Millilitern) oder Dosierpumpe (Dosierung in Anzahl Hüben). Bitte beachten Sie, dass häufig der Begriff “Tropfen” anstatt “Hübe” bei der Dosierung mit der Dosierpumpe verwendet wird.</p>
                        </div>
                        <div class="bg-light-pink mb-3">
                            <div class="accordion-desc attention-desc">
                                <img class="icon" src="/images/private/titration/attention.svg" alt="attention.svg" />
                                <p><strong>Bei Auftreten von unerwünschten Nebenwirkungen reduzieren Sie die Dosis bei der nächsten Einnahme, wie mit Ihrem behandelnden Arzt oder Ihrer behandelnden Ärztin besprochen. Beobachten Sie dabei, ob die Nebenwirkungen erneut auftreten.</strong></p>
                            </div>
                        </div>
                        <div class="accordion-desc">
                            <p>Besprechen Sie die positiven und eventuell unerwünschten Wirkungen mit Ihrer/m behandelnden Arzt/Ärztin bei Ihrem nächsten Termin.</p>
                        </div>
                        <div class="accordion-desc">
                            <p><strong>Therapiehinweise</strong></p>
                            <ul class="has-dot">
                                <li>Bitte nehmen Sie die jeweilige Einzeldosis am Morgen, Mittag und Abend möglichst unmittelbar vor einer Mahlzeit ein</li>
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <li>Die Hormosan Cannabisextrakte können bspw. auf einem Stück Brot oder Butterkeks eingenommen werden</li>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <li>Die Four 20 Pharma Cannabisextrakte können bspw. auf einem Stück Brot oder Butterkeks eingenommen werden</li>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <li>Dronabinol oder Cannabisextrakte können bspw. auf einem Stück Brot oder Butterkeks eingenommen werden</li>
                                    </ng-container>
                                </ng-container>
                                <li>Die Einnahme mit Tee oder Wasser ist nicht empfehlenswert (die öligen Zubereitungen mischen sich nicht mit Wasser)</li>
                                <li>In der Regel tritt eine spürbare Wirkung innerhalb von 30-90 Minuten nach Einnahme auf und kann 4-8 Stunden anhalten.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<ng-template #infoIcon>
    <img src="/images/medizinisches/Info Icon grey.svg" alt="Info Icon grey.svg">
    <ng-container [ngSwitch]="partnerName">
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
            <img src="/images/private/titration/tilray/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
            <img src="/images/private/titration/hormosan/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
            <img src="/images/private/420pharma/Info.svg" alt="Info Icon.svg">
        </ng-container>
        <ng-container *ngSwitchDefault>
            <img src="/images/medizinisches/Info Icon blue.svg" alt="Info Icon.svg">
        </ng-container>
    </ng-container>
</ng-template>
